import * as fromActions from './device.actions';
import { createReducer, on } from '@ngrx/store';
import { DeviceInfo } from '@capacitor/device';

export interface DeviceState {
  entity: DeviceInfo;
  loading: boolean;
  error: string;
}

const initialState: DeviceState = {
  entity: null,
  loading: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.InitDeviceInfo, (state, payload: {}) => ({
    ...state,
    loading: true,
  })),
  on(
    fromActions.InitDeviceInfoSuccess,
    (
      state,
      payload: {
        deviceInfo: DeviceInfo;
      }
    ) => ({
      ...state,
      loading: false,
      entity: payload?.deviceInfo,
    })
  ),
  on(fromActions.InitDeviceInfoError, (state, payload: any) => ({
    ...state,
    loading: false,
  }))
);
